import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import AuthCanvas from "./AuthCanvas";
import TextInput from "../../components/form-group/text-input/TextInput";
import Button from "../../components/button";
import api from "../../api";
import { RouteKeys } from "../routes/route-keys";
import { toastr } from "react-redux-toastr";

interface ResetPasswordFormProps {
  otp: string;
  password: string;
  confirmNewPassword: string;
  requestType: string;
  requestId: string;
}

interface LocationState {
  data: {
    _id: string;
  };
}

const ResetPassword: React.FC = () => {
  const { handleSubmit, errors, control } = useForm<ResetPasswordFormProps>({
    shouldFocusError: true,
  });
  const location = useLocation<LocationState>();
  const requestId = location.state.data._id;

  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const resetPassword = async (body: ResetPasswordFormProps) => {
    const { otp, password, confirmNewPassword, requestType } = body;

    if (password === confirmNewPassword) {
      try {
        await api.auth.setPassword({ otp, password, requestType, requestId });

        window.location.href = "/auth/login";
      } catch (error) {
        // console.log("Password reset failed:", error);
      }
    } else {
      setErrorMessage("Invalid OTP or Passwords do not match");
    }
  };

  const resetOtp = async () => {
    try {
      await api.auth.resendOtp({ requestType: "resetPassword", requestId });
      toastr.success("Success", "OTP sent to your email");
    } catch (error) {
      // console.log("Failed to resend OTP:", error);
    }
  };

  return (
    <AuthCanvas head="Reset Password">
      <form onSubmit={handleSubmit(resetPassword)}>
        <Controller
          control={control}
          name="otp"
          rules={{ required: "OTP is required" }}
          render={({ onChange, value, name }) => (
            <TextInput
              showAsterisk
              placeholder="OTP"
              label="OTP"
              error={errors.otp?.message || errorMessage}
              onChange={onChange}
              name={name}
            />
          )}
        />

        <Controller
          control={control}
          name="password"
          rules={{ required: "Password is required" }}
          render={({ onChange, value, name }) => (
            <TextInput
              showAsterisk
              placeholder="Enter Password"
              label="Enter Password"
              error={errors.password?.message}
              onChange={onChange}
              name={name}
            />
          )}
        />

        <Controller
          control={control}
          name="confirmNewPassword"
          rules={{
            required: "Confirm Password is required",
            validate: (value) =>
              value === control.getValues("password") ||
              "Passwords do not match",
          }}
          render={({ onChange, value, name }) => (
            <TextInput
              showAsterisk
              placeholder="Confirm Password"
              label="Confirm Password"
              error={errors.confirmNewPassword?.message}
              onChange={onChange}
              name={name}
            />
          )}
        />

        <div className="button-outer row">
          <div className="col text-left">
            <Button btnlink onClick={resetOtp}>
              Resend OTP
            </Button>
          </div>
          <div className="col text-right">
            <Button type="submit">Reset Password</Button>
          </div>
        </div>
      </form>
    </AuthCanvas>
  );
};

export default ResetPassword;
